<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onMount } from "svelte";
import uiStore from "../utils/UIStore";

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});

export let newMessage = "";
export let name = "";
export let placeholder = "";
export let handleEnterKey = () => console.log(uiTexts.general.noCallbackGiven); //pass any key event zu parent
export const reset = () => resetTextArea(); //call reset textare from parent
export let isTextFieldActive = false;
export let resizable = false;

onMount(() => {
	const textarea = document.getElementById("auto-resize-textarea");

	// Funktion zur Anpassung der Höhe
	function autoResize() {
		if (textarea == null) {
			return;
		}
		textarea.style.height = "auto"; // Setze die Höhe zurück, um die Scrollhöhe neu zu berechnen
		textarea.style.height = `${textarea.scrollHeight}px`; // Passe die Höhe an die Scrollhöhe an
	}

	// Event-Listener für Eingaben
	textarea.addEventListener("input", autoResize);

	textarea.addEventListener("keydown", (event) => {
		if (event.key === "Enter" && event.shiftKey) {
			event.preventDefault();

			//set newline at cursor position and not at the end of the text
			const cursorPosition = textarea.selectionStart;
			const currentValue = textarea.value;

			const newValue = `${currentValue.slice(0, cursorPosition)}\n${currentValue.slice(cursorPosition)}`;

			textarea.value = newValue;
			textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;

			//resize textarea
			autoResize();
		}
	});

	// Initiale Anpassung
	if (textarea != null && resizable) {
		textarea.style.height = "auto"; // Setze die Höhe zurück, um die Scrollhöhe neu zu berechnen
		let textHeight = textarea.scrollHeight;
		if (textHeight < 400) {
			textarea.style.height = `${textarea.scrollHeight}px`; // Passe die Höhe an die Scrollhöhe an
		} else {
			textarea.style.height = "400px";
		}
	}

	if (!resizable) {
		autoResize();
	}
});

function resetTextArea() {
	const textarea = document.getElementById("auto-resize-textarea");
	if (textarea != null) {
		textarea.style.height = "60px"; // Passe die Höhe an die Scrollhöhe an
	}
}
</script>

<div class="chat-eingabe">
  <textarea
    style="resize: {resizable ? 'true' : 'none'}; max-height: {resizable
      ? 'auto'
      : '400px'};"
    id="auto-resize-textarea"
    on:keypress={handleEnterKey}
    bind:value={newMessage}
    {name}
    {placeholder}
    on:blur={() => (isTextFieldActive = false)}
    on:focus={() => (isTextFieldActive = true)}
  ></textarea>
</div>
